import type {TDashboardDataResponse} from '@kapitalist/contract/endpoints'
import {mkGameId} from '@kapitalist/contract/types'
import {playersMock} from '~/api/endpoints/game/GetGameData/mock'
import Day from '~/utils/Day'

const dashboardDataMock: TDashboardDataResponse = {
  eloLeaderboard: [
    {player: playersMock[0], elo: 9000.01, gamesPlayed: 25},
    {player: playersMock[1], elo: 2882.0, gamesPlayed: 14},
    {player: playersMock[2], elo: 1200.0, gamesPlayed: 2},
  ],
  activeGames: [
    {
      createdAt: Day.today().toISOTimeUTC(),
      gameId: mkGameId('1234'),
      players: playersMock,
      createdBy: playersMock[0].playerId,
    },
    {
      createdAt: Day.today().toISOTimeUTC(),
      gameId: mkGameId('5678'),
      players: playersMock,
      createdBy: playersMock[1].playerId,
    },
  ],
}

export default dashboardDataMock
